import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('InvoiceService', InvoiceService);

  InvoiceService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'InvoiceModalService',
    'ModalWindowConfirmService',
    'WindowModalService',
    'FileSaver',
  ];

  function InvoiceService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    SessionService,
    InvoiceModalService,
    ModalWindowConfirmService,
    WindowModalService,
    FileSaver
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'invoices';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getInvoices: getInvoices,
      getInvoice: getInvoice,
      openInvoiceModal: openInvoiceModal,
      saveInvoice: saveInvoice,
      openAddBookingToInvoice: openAddBookingToInvoice,
      deleteInvoice: deleteInvoice,
      openInvoiceChangeStatus: openInvoiceChangeStatus,
      openSendInvoiceToClient: openSendInvoiceToClient,
      openInvoiceBookingInUsedAlert: openInvoiceBookingInUsedAlert,

      downloadInvoicePdf: downloadInvoicePdf,
      printElectronicTicketPdf: printElectronicTicketPdf,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
      hasRelatedTransactions: hasRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filterCriteria;
    }

    function getInvoices(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
              totalAmounts: response.totalAmounts,
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getInvoice(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          // err
          return false; // err
        }
      );
    }

    function openInvoiceModal(invoice, getItems) {
      InvoiceModalService.openInvoiceDetailModal(invoice, getItems);
    }

    function saveInvoice(invoice, received_payment) {
      // webhookEndPoint
      let method = 'post';
      let url = apiUrl;

      // let webhookUrl = ENV.apiEndpoint + webhookEndPoint;

      if (invoice.id) {
        // edit
        method = 'put';
        url = apiUrl + '/' + invoice.id;
      }

      function success(response) {
        let msg = invoice.status === 'draft' ? 'INVOICE_SAVED_AS_DRAFT' : 'INVOICE_CREATED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { invoice: invoice, received_payment: received_payment },
        success,
        failure
      ); // , webhookUrl: webhookUrl
    }

    function openAddBookingToInvoice(invoice, client, successCallback) {
      InvoiceModalService.openAddBookingToInvoice(invoice, client, successCallback);
    }

    function deleteInvoice(invoice, successCallback) {
      let url = apiUrl + '/' + invoice.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: invoice.company_id },
        function () {
          let params = {
            title: 'DELETE_INVOICE',
            itemName: invoice.invoice_number,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'INVOICE_DELETED',
            company_id: invoice.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function openInvoiceChangeStatus(invoice, successCallback) {
      InvoiceModalService.openInvoiceChangeStatus(invoice, successCallback);
    }

    function openSendInvoiceToClient(clientEmail, successCallback) {
      InvoiceModalService.openSendInvoiceToClient(clientEmail, successCallback);
    }

    function openInvoiceBookingInUsedAlert(successCallback) {
      var modalParams = {
        mode: 'danger',
        title: 'WARNING',
        body: 'INVOICE_BOOKING_IN_USED_ALERT_MSG',
      };

      // var confirmCallback = function () {
      //   return successCallback();
      // };

      ModalWindowConfirmService.open(modalParams, successCallback);
    }

    /* function downloadInvoicePdf(id, company_id, lang) {
      var apiUrlPdf = apiUrl + '/' + id + '/invoice_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: company_id, lang: lang },
        function (response) {
          return response.data;
        },
        function () {
          // console.log(err);
        }
      );
    } */

    function downloadInvoicePdf(invoice, lang) {
      var apiUrlPdf = apiUrl + '/' + invoice.id + '/invoice_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: invoice.company_id, lang: lang },
        function (response) {
          let blobVar = new Blob([response.data], { type: 'application/pdf' });

          FileSaver.saveAs(blobVar, $translate('INVOICE') + ' ' + invoice.invoice_number + '.pdf');
        },
        function () {}
      );
    }

    function printElectronicTicketPdf(id, company_id, lang) {
      var apiUrlPdf = apiUrl + '/' + id + '/electronic_ticket_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: company_id, lang: lang },
        function (response) {
          return response.data;
        },
        function (err) {
          // console.log(err);
        }
      );
    }

    function openRelatedTransactions(transaction, client) {
      let templateUrl = './app/ajs/invoices/modals/invoice-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          clientId: client.id, // client: client
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function hasRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/has_related_transactions/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
